export enum ImportType {
  SHIPPING_RATES = "SHIPPING_RATES",
  CATEGORIES = "CATEGORIES",
  ATTRIBUTES = "ATTRIBUTES",
  PRODUCT_TYPES = "PRODUCT_TYPES",
  PRODUCT_TYPE_ATTRIBUTES = "PRODUCT_TYPE_ATTRIBUTES",
  PRODUCTS = "PRODUCTS",
  PRODUCT_VARIANTS = "PRODUCT_VARIANTS",
  CHANNEL_LISTINGS = "CHANNEL_LISTINGS",
  IMAGES = "IMAGES",
  COLLECTIONS = "COLLECTIONS",
  COLLECTION_PRODUCTS = "COLLECTION_PRODUCTS",
}

export enum DuplicateStrategy {
  UPDATE = "UPDATE",
  SKIP = "SKIP",
  ERROR = "ERROR",
}

export enum ImportFileStatus {
  PENDING = "PENDING",
  STARTED = "STARTED",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  DELETED = "DELETED",
}

export interface ImportPipelineFieldPreview {
  name: string;
  description: string;
  required: boolean;
}

export interface ImportPipelineStep {
  sheetName: string;
  displayName: string;
  position: number;
  dependsOn: string[];
  fieldPreview: ImportPipelineFieldPreview[];
}

export interface ImportPipeline {
  templateUrl: string;
  steps: ImportPipelineStep[];
}

export interface ImportFile {
  id: string;
  status: ImportFileStatus;
  resultUrl: string | null;
  resultSummary: ImportSheetSummary[];
}

export interface ImportSheetSummary {
  sheet: string;
  rowsOk: number;
  rowsSkipped: number;
  rowsError: number;
  sheetMissing: boolean;
  errorMessages: string[];
  skipMessages: string[];
}

export interface ImportError {
  field: string | null;
  message: string;
  code: string;
}
